import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    SettingsIcon,
    Box,
    Menu,
    MenuItem,
    Tooltip,
    IconButton
} from '../../utils/ui';
import { removeLocalData } from '../../services/storageManager';
import Constants from '../../utils/constants';



let menuListStyle = {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1,
    },
    '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 14,
        width: 10,
        height: 10,
        bgcolor: 'background.paper',
        transform: 'translateY(-50%) rotate(45deg)',
        zIndex: 0,
    },
}
function SettingsButton() {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = anchorEl;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        removeLocalData('accessToken');
        removeLocalData('configData');
        removeLocalData('shift');
        removeLocalData('selectedDept');
        removeLocalData('teams');
        navigate(Constants.ROUTES.AUTHENTICATION);
    }
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'settings-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}

                    >
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="settings-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    sx: menuListStyle,
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => navigate(Constants.ROUTES.SETUP_CONFIG + "?config=1")}>
                    Configure
                </MenuItem>
                <MenuItem onClick={logout}>
                    Logout
                </MenuItem>
            </Menu>
        </>
    )
}

export default SettingsButton